import { _ } from "i18n";
import { DatagridBackendFilterType, DatagridFilterInputType, type FilterConfig } from "../../types";
import { DiscoverGamesClubTeamSearchFilterField } from "../constants";

export const teamFilters = {
	all(): FilterConfig[] {
		const clubTeamSearchTitle = _("discover.gamesTable.filterPlaceholder.clubTeamSearch");

		return [
			{
				id: DiscoverGamesClubTeamSearchFilterField.HomeClub,
				label: _("discover.gamesTable.filter.homeClub"),
				type: DatagridFilterInputType.Text,
				field: DiscoverGamesClubTeamSearchFilterField.HomeClub,
				filterType: DatagridBackendFilterType.Search,
				placeholder: _("discover.gamesTable.filterPlaceholder.homeClub"),
				title: clubTeamSearchTitle,
			},
			{
				id: DiscoverGamesClubTeamSearchFilterField.HomeTeam,
				label: _("discover.gamesTable.filter.homeTeam"),
				type: DatagridFilterInputType.Text,
				field: DiscoverGamesClubTeamSearchFilterField.HomeTeam,
				filterType: DatagridBackendFilterType.Search,
				placeholder: _("discover.gamesTable.filterPlaceholder.homeTeam"),
				title: clubTeamSearchTitle,
			},
			{
				id: DiscoverGamesClubTeamSearchFilterField.AwayClub,
				label: _("discover.gamesTable.filter.awayClub"),
				type: DatagridFilterInputType.Text,
				field: DiscoverGamesClubTeamSearchFilterField.AwayClub,
				filterType: DatagridBackendFilterType.Search,
				placeholder: _("discover.gamesTable.filterPlaceholder.awayClub"),
				title: clubTeamSearchTitle,
			},
			{
				id: DiscoverGamesClubTeamSearchFilterField.AwayTeam,
				label: _("discover.gamesTable.filter.awayTeam"),
				type: DatagridFilterInputType.Text,
				field: DiscoverGamesClubTeamSearchFilterField.AwayTeam,
				filterType: DatagridBackendFilterType.Search,
				placeholder: _("discover.gamesTable.filterPlaceholder.awayTeam"),
				title: clubTeamSearchTitle,
			},
		];
	},
};
